



































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';
import * as api from '@/api';
import * as validators from '@/utils/validator';
import { Form as MtdForm } from '@ss/mtd-vue';
interface Form {
    name: string;
    ticketRelated: boolean;
    defaultItemId: number;
    admins: string[];
}
/**
 * 添加二级目录
 *
 * @author xiaokunyu
 * @date 01/11/2010
 */
@Component
export default class AddTypeDialog extends Vue {
    @State(state => state.cti.env)
    env: string;

    @Prop({ default: false })
    isCategory: Boolean;
    @Prop({ default: false })
    isEdit: Boolean;
    @Prop({ default: false })
    visible: Boolean;
    @Prop({ default: 0 })
    id: number;
    @Prop({
        default: () => {
            return [];
        }
    })
    list: any;

    $refs: { formCustom: MtdForm };
    show: Boolean = false;
    btnLoading: Boolean = false;
    formCustom: Form = {
        name: '',
        ticketRelated: false,
        defaultItemId: null,
        admins: []
    };
    relatedArr: number[] = [];
    searchLoading: boolean = false;
    userList: CommonTypes.UserInfoItem[] = [];

    ruleCustom = {
        name: [{ validator: validators.validateName100, trigger: 'blur, change' }],
        defaultItemId: [{ validator: this.validateItemId, trigger: 'change' }]
    };

    validateItemId(_rule, value, callback) {
        if (this.formCustom.ticketRelated && !this.formCustom.defaultItemId) {
            return callback(new Error('请选择默认目录'));
        }
        return callback();
    }

    @Watch('visible', { immediate: true })
    onShowChanged(val) {
        this.show = val;
        if (val) {
            this.formCustom = {
                name: '',
                ticketRelated: false,
                defaultItemId: null,
                admins: []
            };
            this.isEdit && this.getCatalogDetail();
        }
    }
    close() {
        this.$emit('update:visible', false);
    }
    async getCatalogDetail() {
        const res = await api.ctiApi.getCatalogDetail({ id: this.id, level: this.isCategory ? 1 : 2 });
        const { code, data } = res;
        if (code === 200) {
            const { itemId, typeId } = data.defaultCti || {};
            this.formCustom = {
                name: data.name,
                ticketRelated: data.ticketRelated || false,
                defaultItemId: itemId,
                admins: data.admins || []
            };
            if (this.isCategory) {
                this.relatedArr = [typeId, itemId];
                const defaultList = await this.getItemList(typeId);
                this.list.forEach(item => {
                    if (item.id === typeId) {
                        this.$set(item, 'children', defaultList);
                    }
                });
            } else {
                this.relatedArr = [itemId];
            }
        }
    }
    async loadData(node, callback) {
        const result = await this.getItemList(node.id);
        callback(result);
    }
    async getItemList(parentId: number) {
        const res = await api.ctiApi.getItemList({ parentId: parentId });
        const emptyTip = [
            {
                disabled: true,
                id: null,
                isLeaf: true,
                name: '该目录下没有三级目录，请在首页该目录下创建'
            }
        ];
        const { code, data } = res;
        if (code === 200) {
            return data.items && data.items.length
                ? data.items.map(item => {
                      return Object.assign(item, {
                          isLeaf: true
                      });
                  })
                : emptyTip;
        } else {
            return emptyTip;
        }
    }
    ticketRelatedChange(val) {
        this.formCustom.defaultItemId = val[val.length - 1];
    }
    async searchUser(query) {
        if (!query) {
            return;
        }
        this.searchLoading = true;
        try {
            const res = await api.rgApi.searchUser({ keyword: query });
            this.userList = res.data.items as any;
        } catch (e) {
            this.userList = [];
            console.log(e);
        }
        this.searchLoading = false;
    }
    async submit() {
        if (this.btnLoading) {
            return;
        }
        this.$refs.formCustom
            .validate(async valid => {
                if (valid) {
                    this.btnLoading = true;
                    try {
                        if (this.isCategory) {
                            if (this.isEdit) {
                                await api.ctiApi.editCategory(this.id, this.formCustom);
                            } else {
                                await api.ctiApi.addCategory({ name: this.formCustom.name });
                            }
                        } else {
                            if (this.isEdit) {
                                await api.ctiApi.editType(this.id, this.formCustom);
                            } else {
                                await api.ctiApi.addType({ name: this.formCustom.name, parentId: this.id });
                            }
                        }
                        this.$mtd.message({
                            message: `${this.isEdit ? '编辑' : '添加'}${this.isCategory ? '一级' : '二级'}目录成功`,
                            type: 'success'
                        });
                        this.$emit('success');
                        this.close();
                    } catch (e) {
                        console.log(e);
                    }
                    this.btnLoading = false;
                }
            })
            .catch(e => e);
    }
    get createTip() {
        let tipContent = '可以以产品或服务命名二级目录';
        if (this.isCategory) {
            tipContent = '如需创建一级目录';
        } else if (this.isNoCategory) {
            tipContent = '该目录下不创建其他目录，请到对应的一级目录下创建二级目录';
        }
        return tipContent;
    }
    get aboutUrl() {
        const url =
            this.env === 'prod'
                ? '//tt.sankuai.com/ticket/create?category=TroubleTracker&type=CTI管理&item=CTI目录管理'
                : '//tt.cloud.test.sankuai.com/ticket/create?cid=2&tid=3&iid=15';
        return url;
    }
    // 对找不到合适的目录的单独处理
    get isNoCategory() {
        return (this.env === 'prod' && this.id === 14) || (this.env === 'test' && this.id === 657);
    }
}
